//线索库
import React, { useRef, useState } from 'react'
import { Input, message, Modal } from 'antd'
import styles from './index.module.less'
import { useNavigate } from 'react-router-dom'
import {SActionBtn, SFuncModal, SLowcodeList, STableActions} from 'shj-components'
import config from './config.js'
import { fileConfirm } from '@/utils/file'
import {
  exportAudioRecord,
  getCallState,
  getCallType,
  getAudioRecordList,
} from '@/services/callCenter'
import AudioRecordConformity from './modal/audioRecordConformity'
import {getEnums} from "@/services/homeService.ts";

export default function SeatCommunicationCenter(props: any) {
  const { setActiveKey, setClueId } = props
  const navigate = useNavigate()

  const listRef = useRef<any>()
  const [openAudioRecordConformity, setOpenAudioRecordConformity] = useState(false)
  const [params, setParams] = useState({
    callTimeBeginTime: '',
    callTimeEndTime: '',
  })
  const [modalData, setModalData] = useState({}) //弹框数据
  const [exportLoading, setExportLoading] = useState(false)
  const callQualifiedList = [
    { label: '合格', key: true },
    { label: '不合格', key: false },
    // { label: '空', key: 2 },
  ] //通话合格

  // 通话记录状态
  const stateName = {
    dealing: '已接听',
    notDeal: '振铃未接听',
    voicemail: '已留言',
    blackList: '黑名单',
    queueLeak: '排队放弃',
    leak: 'ivr',
  }
  const jumpCallDetails = (value: any) => {
    setActiveKey?.('1')
    setClueId?.(value)
  }
  // 简易弹窗
  const onPlay = (data: Record<string, any>) => {
    SFuncModal({
      width: 400,
      title: '播放',
      vanish: true,
      content: (
        <div style={{textAlign: 'center', padding: '10px 0'}}>
          <audio src={data.monitorFileName} controls>
            浏览器不支持音频播放。
          </audio>
        </div>
      ),
    })
  }
  // 筛选搜索
  const filterSerchData = (objOld: any) => {
    if (!objOld.duration) {
      setParams({
        callTimeBeginTime: '',
        callTimeEndTime: '',
      })
    }
    const newObj = { ...objOld }
    if (newObj.callTime) {
      newObj.callBeginTime = newObj.callTime[0]
      newObj.callEndTime = newObj.callTime[1]
    }
    if (params.callTimeBeginTime && objOld.duration) {
      newObj.callTimeBeginTime = params.callTimeBeginTime
    }
    if (params.callTimeEndTime && objOld.duration) {
      newObj.callTimeEndTime = params.callTimeEndTime
    }

    delete newObj.callTime
    delete newObj.duration
    return newObj
  }

  const fetchList = (values: any) => {
    return new Promise(async (resolve, reject) => {
      try {
        const { current = 1, pageSize = 10, query = {} } = values
        const data = { ...query, orderBys: [{columnName: 'created_time', asc: false}] }
        const _param = filterSerchData(data)
        getAudioRecordList(current, pageSize, _param)
          .then((_records: any) => {
            resolve({ records: _records?.list || [], total: _records?.count || 0 })
          })
          .finally(() => {
            reject({ success: false })
          })
      } catch (e) {
        reject({ success: false })
      }
    })
  }
  const getStatusOptions = () => {
    return Promise.all([
      getEnums('plus-crm', 'com.shj.saas.plus.crm.enums.seat.CallState'),
      getEnums('plus-crm', 'com.shj.saas.plus.crm.enums.seat.CallType'),
    ]).then(res=>{
      const [answerState, callTypeList] = res;
      return {answerState, callTypeList, callQualifiedList}
    })
  }

  const onExport = () => {
    if (exportLoading) return
    setExportLoading(true)
    message.loading({ content: '导出中' })
    const _param = filterSerchData(listRef.current.getSearch().getFieldValue())
    exportAudioRecord(_param)
      .then((res: any) => {
        if (res.status) {
          // exportFile({ response: res, data: res.data });
          // message.success('下载完成');
          fileConfirm()
        } else {
          message.error('下载失败')
        }
      })
      .finally(() => {
        setExportLoading(false)
        message.destroy()
      })
  }
  // 刷新
  const reload = () => {
    const {
      current: { reload },
    } = listRef
    reload()
  }
  const extension = {
    request: { fetchList, getStatusOptions },
    events: { onExport },
    status: { exportLoading },
    // auth,
    customRender: {
      idJump(text: any, record: any) {
        return (
          <div
            style={{ color: '#3D7EFF', cursor: 'pointer' }}
            onClick={() => jumpCallDetails(text)}
          >
            {text}
          </div>
        )
      },
      callStateName(text: string) {
        return stateName[text]
      },
      operation(text: any, record: any) {
        return (
          <STableActions>
            {!record.monitorFileName ? null : (
              <SActionBtn
                onClick={() => {
                  onPlay(record)
                }}
              >
                播放
              </SActionBtn>
            )}
            <SActionBtn
              onClick={() => {
                setModalData(record)
                setOpenAudioRecordConformity(true)
              }}
            >
              评定
            </SActionBtn>
          </STableActions>
        )
      },
      duration({ key, name, form }: any) {
        // 通话时长
        return (
          <div className={styles.callDuration}>
            <Input
              type="number"
              className={styles.input}
              min={0}
              style={{ border: 0, borderRadius: 0 }}
              onChange={(e: any) => {
                const value = e.target.value
                setParams({
                  ...params,
                  callTimeBeginTime: value,
                })
              }}
              placeholder="请输入"
              name="callTimeBeginTime"
            />
            <div style={{ lineHeight: '30px' }}>&nbsp;&nbsp;~&nbsp;&nbsp;</div>
            <Input
              type="number"
              id="2"
              className={styles.input}
              min={0}
              style={{ border: 0, borderRadius: 0 }}
              onChange={e => {
                const value = e.target.value

                setParams({
                  ...params,
                  callTimeEndTime: value,
                })
              }}
              placeholder="请输入"
              name="callTimeEndTime"
            />
          </div>
        )
      },
    },
  }

  return (
    <div>
      <SLowcodeList config={config} ref={listRef} searchMode="group" {...extension} />
      <AudioRecordConformity
        open={openAudioRecordConformity}
        onCancel={() => {
          setOpenAudioRecordConformity(false)
        }}
        data={modalData}
        fn={reload}
      />
    </div>
  )
}
